<script setup lang="ts">
import type { FormSubmitEvent } from '@nuxt/ui'
import { object, string, type InferType } from 'yup'

const toast = useToast()

const props = defineProps({
    blok: Object,
})

const schema = object({
    email: string().email().required(props.blok?.required),
    name: string().required(props.blok?.required),
})

type Schema = InferType<typeof schema>

const state = reactive({
    email: '',
    name: '',
    country: '',
})

async function handleSubmit(event: FormSubmitEvent<Schema>) {
    const response = await $fetch('/api/mailchimp', {
        method: 'POST',
        body: {
            email: state.email,
            name: state.name,
            country: state.country,
        },
    })

    if (response.id) {
        toast.add({
            title: 'Thank you for subscribing',
            icon: 'i-heroicons-check-circle',
            color: 'success',
        })
    }
    else {
        toast.add({
            title: response.detail,
            icon: 'i-heroicons-x-circle',
            color: 'error',
        })
    }
}
</script>

<template>
    <section class="section bg-[#947DBA]">
        <UiContainer>
            <div class="grid grid-cols-12">
                <div class="col-span-6 max-[769px]:hidden">
                    <div class="relative">
                        <img
                            :src="blok?.envelope?.filename"
                            :alt="blok?.envelope?.alt"
                            class="absolute top-1/2 left-0 right-0 -translate-y-1/2"
                        >
                    </div>
                </div>
                <div class="col-span-6 max-[769px]:col-span-12">
                    <header class="global-text text-center">
                        <StoryblokRichText :doc="blok?.header" />
                    </header>
                    <UForm
                        id="newsletter"
                        :state="state"
                        :schema="schema"
                        class="mt-8 w-full flex flex-col gap-4"
                        @submit="handleSubmit"
                    >
                        <UFormField
                            :label="blok?.email_label"
                            class="w-full"
                            name="email"
                        >
                            <UInput
                                v-model="state.email"
                                class="w-full"
                                size="xl"
                            />
                        </UFormField>
                        <UFormField
                            :label="blok?.name_label"
                            name="name"
                            class="w-full"
                        >
                            <UInput
                                v-model="state.name"
                                class="w-full"
                                size="xl"
                            />
                        </UFormField>
                        <UFormField
                            v-if="blok?.country_label"
                            :label="blok?.country_label"
                            name="country"
                            class="w-full"
                        >
                            <UInput
                                v-model="state.country"
                                class="w-full"
                                size="xl"
                            />
                        </UFormField>
                        <footer class="flex justify-center pt-8">
                            <UButton
                                type="submit"
                                form="newsletter"
                                :label="blok?.submit"
                                size="xl"
                            />
                        </footer>
                    </UForm>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
